import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getTokenCookie } from "../request";
import { deleteItemStore, getItemStore, setItemStore } from "../../untils";

export const URL_AFTER_AUTHORIZATION_KEY = "urlAfterAuthorization";

export interface userState {
    user_role: string;
    tkn: string | null;
    urlAfterAuthorization: string | null;
    email: string;
}

interface Field {
    name: string;
    value: string & null;
}

const initialState: userState = {
    user_role: "guest",
    tkn: getTokenCookie() || null,
    urlAfterAuthorization: getItemStore(URL_AFTER_AUTHORIZATION_KEY) || null,
    email: "",
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        updateUserField(state, action: PayloadAction<Field>) {
            state[action.payload.name as keyof userState] =
                action.payload.value;

            if (action.payload.name === URL_AFTER_AUTHORIZATION_KEY) {
                if (action.payload.value) {
                    setItemStore(
                        URL_AFTER_AUTHORIZATION_KEY,
                        action.payload.value
                    );
                } else {
                    deleteItemStore(URL_AFTER_AUTHORIZATION_KEY);
                }
            }
        },
        updateUser(state, action: PayloadAction<userState>) {
            state = Object.assign(state, action.payload);
        },
        clearTkn(state: userState) {
            state = Object.assign(state, { tkn: null });
        },
    },
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
